'use client';
import styled from 'styled-components';

export const StyledCTAGroupComponent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${props => props.theme.spacing(4)};

  @media ${props => props.theme.tablet} {
    grid-template-columns: repeat(
      ${props => props.$buttonsPerRow || 2},
      minmax(0, 1fr)
    );
  }
`;

export const CTAButtonWrapper = styled.div`
  ${props => props.theme.getFocusOutline()};
  width: max-content;
`;
